import { useMemo } from 'react';
import { mergeSpringboardTabs } from './mergeSpringboardTabs';
import { SPRINGBOARD_TABS } from './tabs';
import { useSpringboardCategoryCustomization } from './useSpringboardCategoryCustomization';

export const useSpringboardTabs = () => {
  const customizationQuery = useSpringboardCategoryCustomization();

  const tabs = useMemo(
    () =>
      mergeSpringboardTabs(
        SPRINGBOARD_TABS,
        customizationQuery.data?.hasCustomization ? customizationQuery.data.categories : undefined,
      ),
    [customizationQuery.data],
  );

  return {
    tabs,
    isLoading: customizationQuery.isLoading,
    isError: customizationQuery.isError,
    customization: customizationQuery.data,
  };
};
